import VacationSchedule from "./VacationSchedule";

export default VacationSchedule;
